import React from 'react';
import TaskList from './Tasks/TaskList';
import './Tasks/Task.css';

const Home = () => {
  return (
    <div>
        <TaskList />
    </div>
  );
};

export default Home;
